import React from 'react';
import './workHistory.scss';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
const jobsArray = [
	{
		date: 'AUG 2023 – PRESENT',
		title: 'Senior Front-End Engineer',
		company: 'Home Depot',
		location: 'Remote',
		logo: 'THD_logo.jpg',
		description: {
			summary:
				`Initial reason for hire was to take care of priority new feature work and fix the current state of the Angular application to be built for growth. The application is build for Store Associates picking orders to be picked up or delivered.`,
			accomplishments: [
				'Within the first month released a No Barcode UI feature that enables manual picking of an order item that contained no scanning barcode.  This had to be implemented in 3 different application areas.  Built reusable components to enable ease of implementation.  Deployed on time.',
				'Did a thorough analysis of the Angular Application to present the current state and what is required to enhance and cleanup the application and why it is necessary.',
				'Replaced Cordova with Internal Mobile Sidecar Layer.'
			],
			skills: ['JavaScript, Typescript, Angular, React, Node.JS, HTML5, SCSS, Github, Cordova, Bluetooth Printing']
		},
		website: 'https://homedepot.com'
	},
	{
		date: 'JUL 2012 – PRESENT',
		title: 'OWNER AND SOFTWARE ENGINEER',
		company: 'Goldfarb Development',
		location: 'Remote',
		logo: 'gd_logo.fw.png',
		description: {
			summary:
				`I have owned and maintained this side business of building websites and applications for clients.`,
			accomplishments: [
				'Built several websites mainly with WordPress.',
				'Fixing legacy and creating a more modern version of a real estate agent application with PHP on the backend and Bootstrap and OOP JavaScript on the front end.',
				'Built custom CMS systems.',
				'Design to Code Web Pages.',
				'Built a customized PHP application based on an Excel Application.',
				'Built both React and Angular Apps for future market release.'
			],
			skills: ['HTML5, CSS3, SCSS, WordPress, PHP, Symfony, JavaScript, Typescript, Angular, React, MySQL, Firebase / FireStore']
		},
		website: 'https://gregorygoldfarb.com'
	},
	{
		date: 'JUN 2023 – AUG 2023',
		title: 'ANGULAR APPLICATION PROJECT',
		company: 'Goldfarb Development',
		location: 'Remote',
		logo: 'gd_logo.fw.png',
		description: {
			summary:
				(<>
					While looking for job opportunities, my son gave me an idea for an Angular Application I call <a href="https://gym-timer.com" target="_blank" rel="noopener noreferrer">
						Gym Timer</a> to be used in the gym during customized for a workout. I built it using Angular using Material Design with Bootstrap for my framework.</>
				),
			accomplishments: [
				(<>I built all the initial features including:
					<ul>
						<li>Customized Gym Timer</li>
						<li>SSO Login</li>
						<li>Customized Exercises with Individualizes Timers</li>
						<li>Edit and Delete Workouts</li>
						<li>Saving Daily Workouts</li>
						<li>Google API to provide YouTube Video Explanations for each workout.</li>
					</ul>
				</>),
			],
			skills: ['JavaScript, Typescript, Angular, React, Node.JS, HTML5, SCSS, Github, Cordova, Bluetooth Printing']
		},
		website: 'https://gym-timer.com'
	},
	{
		date: 'November 2021 - June 2023',
		title: 'Senior Front-End Engineer',
		company: 'Intelycare',
		location: 'Quincy, MA',
		logo: 'Intelycare_Logo.jpeg',
		website: 'https:/intelycare.com',
		svg: (<svg xmlns="http://www.w3.org/2000/svg" width="240" height="50" viewBox="0 0 240 50" fill="none"><g clip-path="url(#clip0_2960_2)"><path d="M78.6453 15.7748H83.6746V22.5042L90.1953 22.5103V26.7984L83.6746 26.7923V35.724C83.6746 38.7446 85.2511 39.4086 86.8783 39.4086H90.2383V43.7014H85.8216C82.5461 43.7014 78.6453 42.6106 78.6453 35.4995L78.6453 15.7748Z" fill="#009AE9"/><path d="M235.026 32.72C235.02 33.2849 234.985 33.8491 234.922 34.4105H218.272C218.406 35.454 218.775 36.4542 219.35 37.3378C219.881 38.1304 220.6 38.7817 221.444 39.2344C222.292 39.6615 223.23 39.8807 224.181 39.8735C225.425 39.8735 226.441 39.633 227.229 39.152C228.034 38.6537 228.653 37.9082 228.992 37.0288H234.466C234.077 38.3636 233.405 39.6006 232.496 40.657C231.524 41.7948 230.314 42.7093 228.95 43.3371C226.427 44.518 223.544 44.7 220.89 43.846C218.236 42.9919 216.01 41.1661 214.664 38.74C213.724 37.0033 213.233 35.0627 213.233 33.0914C213.233 31.1202 213.724 29.1796 214.664 27.4428C215.604 25.7309 216.996 24.3059 218.692 23.3214C220.387 22.337 222.321 21.8303 224.285 21.8561C226.247 21.8226 228.18 22.3368 229.863 23.3404C231.467 24.3015 232.778 25.6766 233.657 27.3192C234.571 28.9737 235.042 30.8332 235.026 32.72ZM229.904 30.5555C229.831 29.7619 229.52 29.0081 229.013 28.391C228.469 27.7034 227.764 27.1583 226.96 26.8035C225.955 26.3353 224.845 26.1365 223.739 26.2269C222.633 26.3173 221.57 26.6938 220.656 27.3189C219.605 28.0472 218.88 29.126 218.479 30.5555L229.904 30.5555Z" fill="#009AE9"/><path d="M206.002 22.5026V24.3234C206.002 24.3234 208.349 21.8559 211.552 21.8559H211.814V26.1486C208.388 26.1486 206.681 29.9023 206.681 29.9023C206.204 31.12 205.974 32.4188 206.002 33.7247V43.7027H201.677V22.5026H206.002Z" fill="#009AE9"/><path d="M127.66 45.6636C129.476 45.6636 130.184 45.1183 130.575 44.4793C130.962 43.872 131.279 43.2231 131.519 42.5452L131.761 41.8324L123.84 21.8788H128.966L133.831 34.5433L134.354 36.7017L134.897 34.5637L139.682 21.8789H144.868L136.807 42.3417C135.989 44.4319 135.178 46.0132 134.374 47.0856C133.689 48.0763 132.733 48.8531 131.62 49.3253C130.601 49.7463 129.295 49.9566 127.7 49.9565H123.872V45.6636H127.66Z" fill="#009AE9"/><path d="M116.027 15.7697H121.056V43.7065H116.027V15.7697Z" fill="#009AE9"/><path d="M113.243 32.7202C113.237 33.285 113.203 33.8491 113.14 34.4105H96.6299C96.7633 35.4529 97.1285 36.4529 97.6992 37.3379C98.2122 38.1323 98.9221 38.7826 99.7609 39.2266C100.6 39.6706 101.539 39.8934 102.49 39.8736C103.723 39.8736 104.731 39.6331 105.512 39.1521C106.312 38.6517 106.925 37.9062 107.26 37.0286H112.688C112.303 38.3618 111.637 39.5986 110.734 40.657C109.772 41.7931 108.573 42.7076 107.219 43.3369C104.713 44.5133 101.848 44.6925 99.2136 43.8375C96.5789 42.9824 94.3742 41.1582 93.0525 38.7397C92.121 37.0004 91.6339 35.0608 91.6339 33.0911C91.6339 31.1213 92.121 29.1817 93.0525 27.4425C93.9769 25.7352 95.3549 24.3119 97.0366 23.327C98.7184 22.3421 100.64 21.8333 102.592 21.8558C104.499 21.8212 106.379 22.3138 108.02 23.2785C109.661 24.2433 110.999 25.6422 111.886 27.3188C112.792 28.9759 113.259 30.8346 113.243 32.7202ZM108.164 30.5557C108.092 29.7632 107.784 29.0098 107.28 28.3912C106.743 27.7046 106.044 27.1595 105.245 26.8037C104.25 26.3355 103.147 26.1366 102.05 26.227C100.952 26.3175 99.8983 26.6942 98.9945 27.3189C97.9526 28.0473 97.233 29.1262 96.8356 30.5556L108.164 30.5557Z" fill="#009AE9"/><path d="M47.6407 15.7657H52.67V43.7026H47.6407V15.7657Z" fill="#009AE9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M59.7787 23.6413V22.5025H55.4542V43.7026L60.4708 43.6943V32.5304C60.4708 31.0953 60.4626 26.7427 65.6842 26.7427C70.9058 26.7427 70.832 31.1998 70.832 32.5386V43.7028H75.8611V31.8439C75.8758 29.2096 74.8356 26.6774 72.9695 24.8043C71.1034 22.9312 68.5641 21.8707 65.9103 21.856H65.4579C63.4244 21.8537 61.4401 22.4774 59.7787 23.6413V23.6413Z" fill="#009AE9"/><path fill-rule="evenodd" clip-rule="evenodd" d="M194.602 41.9958C192.653 43.5083 190.25 44.3289 187.776 44.3265C184.797 44.2931 181.95 43.0947 179.855 40.9913C177.76 38.8879 176.585 36.0492 176.585 33.0912C176.585 30.1332 177.76 27.2945 179.855 25.1911C181.95 23.0877 184.797 21.8893 187.776 21.8559C190.25 21.8535 192.653 22.674 194.602 24.1864V22.5026H198.893V43.7027H194.602V41.9958ZM194.569 32.9477C194.556 34.7264 193.833 36.4275 192.559 37.6783C191.285 38.9292 189.564 39.6279 187.772 39.6214C185.98 39.615 184.264 38.9038 182.999 37.6438C181.734 36.3838 181.024 34.6775 181.024 32.8988C181.024 31.1201 181.734 29.4139 182.999 28.1539C184.264 26.8938 185.98 26.1827 187.772 26.1762C189.564 26.1698 191.285 26.8685 192.559 28.1193C193.833 29.3702 194.556 31.0712 194.569 32.8499V32.9477Z" fill="#009AE9"/><path d="M146.022 30.0033C146.022 22.0787 152.429 15.7592 160.533 15.7592C166.334 15.7592 172.518 19.1296 173.792 26.4122H168.658C167.567 22.2192 164.313 20.3333 160.392 20.3333C155.198 20.3333 151.054 24.2053 151.054 30.0234C151.054 35.9417 155.198 39.6733 160.392 39.6733C164.292 39.6733 167.567 37.8075 168.638 33.6145H173.791C172.518 40.9172 166.394 44.2676 160.533 44.2676C152.429 44.2676 146.022 37.9279 146.022 30.0033Z" fill="#009AE9"/><path d="M21.58 50H15.8825V25.926C15.8825 24.0676 16.6262 22.2853 17.95 20.9713C19.2738 19.6572 21.0693 18.919 22.9414 18.9189H34.9417V36.7368C34.9417 38.4785 34.5961 40.2033 33.9246 41.8124C33.2531 43.4216 32.2689 44.8838 31.0281 46.1154C29.7874 47.347 28.3144 48.3239 26.6933 48.9905C25.0722 49.657 23.3347 50.0001 21.58 50Z" fill="#009AE9"/><path d="M13.3615 15.7657H28.5885V36.6867C28.5885 37.6068 28.4059 38.518 28.0512 39.3681C27.6964 40.2183 27.1765 40.9907 26.521 41.6414C25.8655 42.292 25.0874 42.8082 24.2309 43.1603C23.3745 43.5124 22.4566 43.6937 21.5296 43.6937H0V29.029C0 25.5114 1.40772 22.1378 3.91348 19.6505C6.41925 17.1631 9.81779 15.7657 13.3615 15.7657V15.7657Z" fill="#E5098C"/><path d="M29.5969 12.6126H22.2355V5.3053C22.2355 3.89824 22.7986 2.54882 23.8009 1.55389C24.8032 0.558949 26.1626 0 27.5801 0L34.9417 0V7.30731C34.9417 8.00403 34.8034 8.69392 34.5348 9.33759C34.2662 9.98127 33.8725 10.5661 33.3762 11.0588C32.8799 11.5514 32.2907 11.9422 31.6422 12.2088C30.9938 12.4754 30.2988 12.6126 29.5969 12.6126V12.6126Z" fill="#009AE9"/><path d="M22.9414 18.9189C21.0693 18.9189 19.2738 19.6572 17.95 20.9713C16.6262 22.2853 15.8825 24.0676 15.8825 25.926V43.6937H21.5297C22.4567 43.6937 23.3746 43.5125 24.2311 43.1604C25.0875 42.8082 25.8656 42.2921 26.5211 41.6414C27.1766 40.9908 27.6966 40.2183 28.0513 39.3682C28.406 38.5181 28.5886 37.6069 28.5886 36.6867V18.9189H22.9414Z" fill="#450D8A"/><path d="M234.728 20.6081H233.691V20.2274H236.195V20.6081H235.156V23.4844H234.729L234.728 20.6081Z" fill="#009AE9"/><path d="M236.762 20.2274H237.131L238.379 21.8702H238.381L239.626 20.2274H240V23.4844H239.573V20.9123L238.439 22.4139H238.316L237.189 20.9099V23.4844H236.762V20.2274Z" fill="#009AE9"/></g><defs><clipPath id="clip0_2960_2"><rect width="240" height="50" fill="white"/></clipPath></defs></svg>),
		description: {
			summary:
				`Intelycare provides an application that helps medical facilities and nurses connect to fill positions. My job is to maintain and build the front end of their application built on an AngularJS framework. I am also involved in building their new updated Angular version.
				 This involves building new components and features and setting the standard for UI/UX including CSS organization. In charge of front-end code review. Currently learning Java for future projects, pair
				 programming with team members.`,
			accomplishments: [
				'Hit the ground running, fixing initial bugs on the legacy product, and building components and features on the new Angular version of the internal Intelycare Hub Application as well as the scheduling application for medical facilities.',
				'Applied expertise of proper HTML/CSS toward project improvement',
				'Mentor and bring incoming engineers up to speed to hit the ground running',
				'Help QE engineers learn how to understand whether something is a bug or whether the AWS environment is the main issue to resolve.',
				'Document front end coding standards',
				'Taking on more of a full stack role with Java and PHP building Billing Services',
			],
			skills: ['Agile methodologies, AWS, gRPC, HTTP/2, Java, PHP, JavaScript, Micro Services, Typescript, AngularJS, and Angular, HTML5, CSS3, SASS, MySQL, Mobile Development']
		},
	},
	{
		date: 'July 2017 – November 2021',
		title: 'Senior Software Engineer',
		company: 'ERT',
		location: 'Charlestown, MA',
		website: 'https://www.ert.com/',
		logo: 'ERT_Logo.png',
		description: {
			summary: 'Part of an 8 member agile team of developers and QA Engineers working on a JavaScript-based Mobile and Web Application that benefits doctors and patients in providing crucial data for various drug and Durable Medical Equipment trials.  We are a highly committed team that takes each other’s code seriously, reviewing each promotion and challenges each other to be better as individuals and a team.',
			accomplishments: [
				'Fixed countless bugs while implemented new features',
				'Applied expertise of proper HTML/CSS toward project improvement' +
				'Build Angular version of existing Backbone Application to demonstrate its capabilities and advantages verses a React Version',
			],
			skills: [
				'Agile methodologies, ES6, LESS, OOP, Accurev (source control), Rally (bug tracking)',
				(
					<>
						<dt>UDEMY Certifications:</dt>
						<ul>
							<li><dd>Progressive Web Applications, React and Redux certifications, Firebase</dd></li>
						</ul>
					</>
				)
			]
		}
	},
	{
		date: 'Oct 2015 – July 2017',
		title: 'Software Engineer',
		company: 'BAE Systems Applied Intelligence',
		location: 'Boston, MA',
		logo: 'BAE Systems Logo.jpeg',
		website: 'https://www.baesystems.com',
		description: {
			summary: 'I was a member of a team of 8 working on one Web Application that displays data about various device usage retrieved from multiple platforms. I am in an Agile Environment with 2-week sprints and releases every 4-6 months.',
			accomplishments: [
				'Built various application features and templates involving from the back to front end, including customizing and extending jQuery Data Tables with column and global filtering, multi-tab applications with Data Tables and Forms with proper form validation',
				'Organized all LESS styles to be uniform to components, modules, and utilities',
				'Lots of debugging on the PHP and JavaScript side'
			],
			skills: ['Agile work environment, PHP Storm, Vagrant Box, Docker, Composer, Assetic, Symfony 3, OOP, jQuery Data Tables, Angular, jQuery DateTimePicker']
		},
	},
	{
		date: 'Aug 2014 – Oct 2015',
		title: 'User Interface Engineer',
		company: 'Bridgeline Digital Inc.',
		website: 'https://www.bridgeline.com/',
		location: 'Burlington, MA',
		logo: 'Bridgeline Digital Logo.png',
		description: {
			summary: 'Front and Backend Web Development existing and new clients in an ASP.net environment (HTML5, CSS3, SASS, Compass, jQuery, JavaScript, Bootstrap 3, iApps, ASP.net)',
			accomplishments: [
				(<>ASCD – ascd.org
					<ul>
						<li>Built all front end code from the ground up</li>
						<li>Bootstrap Framework, jQuery, plugins, responsive design</li>
					</ul></>),
				(<>Franklin Square – franklinsquare.com
					<ul>
						<li>Maintenance and additions</li>
						<li>Made more responsive and custom in terms of front end options for the end user</li>
						<li>Recreated the home page slider and all banners</li>
					</ul></>),
				(<>Allscripts – allscripts.com
					<ul>
						<li>Phase I and II of custom front and backend template building</li>
					</ul></>),
				(<>Partners Healthcare – innovation.partners.org
					<ul>
						<li>Replaced flash slider with modern custom slider</li>
					</ul></>
				)
			],
			skills: ['ASP.net and iApps technology, SourceTree, BitBucket']
		},

	},
	{
		date: 'Aug 2014',
		title: 'Contract Web Developer',
		company: 'Bose',
		location: 'Framingham, MA',
		logo: 'Bose Logo.png',
		website: 'https://www.bose.com',
		description: {
			summary: 'Create a custom Tumblr website for a Bose and NFL campaign.'
		}
	},
	{
		date: 'Feb 2014 - Aug 2014',
		title: 'Lead Web Developer',
		company: 'Boathouse Inc.',
		location: 'Waltham, MA',
		logo: 'Boat House Logo.png',
		website: 'https://www.boathouseinc.com',
		description: {
			summary: 'Agency experience involving multiple avenues of digital technology',
			accomplishments: [
				(<>Partners Healthcare – innovation.partners.org
					<ul>
						<li>Replaced flash slider with modern custom slider</li>
					</ul>
				</>),
				(<>Urban League of Eastern Massachusetts - ypnulem.org
					<ul>
						<li>Coded from ground up in WordPress with ecommerce extension</li>
						<li>Responsive Design</li>
					</ul></>),
				(<>Belmont Savings Bank – belmontsavings.com
					<ul>
						<li>Maintenance and additions</li>
					</ul>
				</>),
				'MEFA, Northern Pass – Flash Banners using AS3',
				'Boathouse Website Custom CMS – currently not accessible',
				'Natixis – responsive pie chart animation (charts.js)',
			],
			skills: [
				(<><dt>Front and Back End Web Development:</dt>
					<ul>
						<li><dd>HTML5, CSS3, SASS, jQuery, JavaScript, PHP, MySQL, WordPress</dd></li>
						<li>PHP MVC Framework (CodeIgniter), Rich Media using Flash/AS3, Point Roll</li>
						<li>Involved in backend MVC development of company website</li>
					</ul>
				</>),
				'Create flash banners using AS3',
				'Develop and maintain custom built WordPress websites (e-commerce included)'
			]
		},
	},
	{
		date: 'May 2013-Feb 2014',
		title: 'Web Support Developer',
		company: 'Precision Design Studios',
		location: 'Providence, RI',
		logo: 'PDS Logo.png',
		description: {
			summary: 'Initial company hands on web development expereince with Demandware platform',
			accomplishments: [
				'Resolved various problems and created implementations on ecommerce websites',
				'Heavily used jQuery and JavaScript',
				(<>Involved in production of Fifth and Pacific Websites:
					<ul>
						<li><a target="_blank" rel="noopener noreferrer" href="https://katespade.com">katespade.com</a></li>
						<li><a target="_blank" rel="noopener noreferrer" href="https:://saturday.com">saturday.com</a></li>
						<li><a target="_blank" rel="noopener noreferrer" href="https://jackspade.com">jackspade.com</a></li>
						<li><a target="_blank" rel="noopener noreferrer" href="https:://juicycouture.com">juicycouture.com</a></li>
						<li><a target="_blank" rel="noopener noreferrer" href="https://luckybrand.com">luckybrand.com</a></li>
					</ul></>
				)
			],
			skills: [
				'DemandewareScript, Javascript, HTML5, CSS, Cookies, CMS, eCommerce, Debugging'
			]
		},
		website: 'https://www.precisiondesignstudios.com/'
	}]
const WorkHistory = (props) => {
	const active = props.active ? ' active' : '';
	return (
		<section className={`WorkHistory${active}`}>
			<article>
				<h1>WORK HISTORY</h1>
				<VerticalTimeline layout="1-column">
					{
						jobsArray.map(job => {
							return (
								<VerticalTimelineElement
									className="vertical-timeline-element--work"
									contentStyle={{ }}
									contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
									date={`Date: ${job.date}`}
									iconStyle={{ background: `url("/assets/images/${job.logo}") no-repeat`, backgroundSize: 'contain', color: '#fff'}}
								>
									<a className="float-right" rel="noopener noreferrer" target="_blank" href={job.website}>
										{job.svg ? job.svg : (<img style={{width: '100%', maxWidth: '100px'}} alt={job.company} src={`/assets/images/${job.logo}`} />)}
									</a>
									<h3 className="vertical-timeline-element-title">{job.title}</h3>
									<h4 className="vertical-timeline-element-subtitle">{job.company}</h4>

									<h5 className="vertical-timeline-element-subtitle mb-3 pb-2">{job.location}</h5>
									<dl className="row">
										<dt className="col-md-3"><u>Summary:</u></dt>
										<dd className="offset-1 offset-lg-0 col-11 col-lg-9">
											{job.description.summary}
										</dd>
										{job.description.accomplishments &&
											(<>
												<dt className="col-md-3"><u>Accomplishments:</u></dt>
												<dd className="offset-1 offset-lg-0 col-11 col-lg-9">
													<ul className="pl-3">
														{job.description.accomplishments.map(accomplishment => (<li>{accomplishment}</li>))}
													</ul>
												</dd>
											</>)
										}
										{job.description.skills &&
											(<>
												<dt className="col-md-3"><u>Tech Stack:</u></dt>
												<dd className="offset-1 offset-lg-0 col-11 col-lg-9">
													<ul className="pl-3">
														{job.description.skills.map(skill => (<li>{skill}</li>))}
													</ul>
												</dd>
											</>)
										}
									</dl>
								</VerticalTimelineElement>
							)
						})
					}
				</VerticalTimeline>
			</article>
		</section>
	);
};

export default WorkHistory;
